const mapToLowerCase = (arr: string[]) => arr.map((item) => item.toLowerCase());
const joinWithComma = (arr: string[]) => arr.join(',');

// https://github.com/storyvine/storyvine-backend/blob/95e1ad635cd231cdc203d5d29d27d5aaafcc336e/app/services/package_services/asset_validator.rb#L6
export const ALLOWED_ASSET_TYPES = {
  image: mapToLowerCase(['.jpg', '.jpeg', '.gif', '.bmp', '.png']),
  video: mapToLowerCase([
    // widely supported (the backend converts formats outside this group)
    '.mp4', // MPEG-4 Part 14
    '.webm', // WebM Video
    '.ogv', // Ogg Video
    // partially supported in browsers
    '.mov', // QuickTime Movie
    '.m4v', // MPEG-4 Video
    // not reliably supported in browsers
    '.mpeg', // MPEG-1 or MPEG-2 Video
    '.mpg', // MPEG-1 or MPEG-2 Video
    '.3gp', // 3GPP Multimedia
    '.ts', // MPEG Transport Stream
    // not supported in browsers:
    '.avi', // Audio Video Interleave
    '.flv', // Flash Video
    '.wmv', // Windows Media Video
    '.mkv', // Matroska Video
    '.vob', // DVD Video Object
    '.rm', // RealMedia Video
    '.rmvb', // RealMedia Variable Bitrate
    '.asf', // Advanced Systems Format
    '.m2ts', // Blu-ray BDAV Video
    '.f4v', // Flash MP4 Video
  ]), // note ffmpeg supports more formats - these are just the most common
};

// the frontend uses the allowed video asset types for the video upload input,
// in case the definition above shows insufficient consider using mime-types;
// see the following link for more information:
// https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input/file#accept

export const ALLOW_ASSET_TYPES_STRING = {
  image: joinWithComma(ALLOWED_ASSET_TYPES['image']),
  video: joinWithComma(ALLOWED_ASSET_TYPES['video']),
};

export const VIRTUALIZED_DROPDOWN_PER_PAGE = 20;

// dashboard user roles overview
// https://storyvine.atlassian.net/wiki/spaces/SN/pages/559218698/Dashboard+User+Roles+Permissions
export enum AdminUsers {
  Manager = 'Manager',
  Moderator2 = 'Moderator 2.0',
  AccountAdmin = 'Account Admin',
  ModeratorSecure = 'Moderator - Secure',
  ModeratorSecure2 = 'Moderator - Secure 2.0',
  Superadmin = 'Superadmin',
  Moderator = 'Moderator',
}

export enum StorymakerUsers {
  Reviewer = 'reviewer',
}
